export const errorMessageContentInvalid = `
    <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
        <div>Følgende felfer er feil</div>
        <div>Ugyldig postnummer</div>
        <div>Klikk på teksten for å fjerne denne meldingen.</div>
    </div>
`;

export const errorMessageContentNumberOnly = `
    <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
        <div>Følgende felfer er feil</div>
        <div>Fra</div>
        <div>Klikk på teksten for å fjerne denne meldingen.</div>
    </div>
`;

export const errorMessageContentMinMax = `
    <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
        <div>Følgende felfer er feil</div>
        <div>Fra postnr må være større enn til postnr.</div>
        <div>Klikk på teksten for å fjerne denne meldingen.</div>
    </div>
`;
